/*
 * @Author: Teemo Ding
 * @Date: 2021-07-20 09:04:18
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-21 15:18:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Components/AddPaymentModal/AddPaymentModal.tsx
 */
/**
 *  Added a Channel popup
 *  Author: Teemo
 *  CreatedAt: 2021-03-03
 */

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import Search from '@/src/components/Antd/Search/Search';
import Row from '@/src/components/Layouts/Row/Row';
import { SearchOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './AddPaymentModal.less';
import RadioItem from './SaleChannelRadioItem/SaleChannelRadioItem';

const AddPaymentModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setShowModal, defaultRadioItem, inputPlaceHolder, onConfirm } = props;
  const [newProvider, setProvider] = useState<string>('');
  const [search, setSearch] = useState<string>('');
  const [radioList, setRadioList] = useState(defaultRadioItem);

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleAddChannel = (e) => {
    setProvider(e.target.value);
  };

  const onSearch = (value) => {
    if (value) {
      const data = radioList.filter(
        (o) =>
          o.title.toLowerCase().includes(value.toLowerCase()) ||
          o.description.toLowerCase().includes(value.toLowerCase()),
      );
      setProvider('');
      setRadioList(data);
    } else {
      setRadioList(defaultRadioItem);
    }
  };

  return (
    <div>
      <Search
        className={css.searchInputClassName}
        onPressEnter={(e) => onSearch(e.target.value)}
        enterButton={getI18n('general.filterGroup.search')}
        prefix={<SearchOutlined />}
        onSearch={onSearch}
        value={search}
        allowClear
        onChange={(value) => setSearch(value)}
        placeholder={inputPlaceHolder}
      />
      <Row
        elements={[
          {
            child: (
              <div className={css.radioContain}>
                <RadioItem
                  radioList={radioList}
                  onChange={handleAddChannel}
                  value={newProvider}
                  className={css.radioList}
                />
              </div>
            ),
          },
        ]}
      />

      <ModalFooter
        onCancel={handleCancel}
        okText={getI18n('general.confirm')}
        hideOkButton={!newProvider}
        onOk={() => onConfirm(newProvider)}
      />
    </div>
  );
};
export default AddPaymentModal;
